import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../context/authContext";
import { useChat } from "../../../context/chatContext";
import createAxiosInstance from "../../../utils/axiosConfig";
import { useCases } from "../../../utils/constants";
import { framework_domains } from "../../../utils/endpoints";
import { FrameworkDomain } from "../../../utils/interfaces";
import ChatHeader from "../../common/chat/chatHeader";
import ChatHistory from "../../common/chatHistory";
import Footer from "../../common/footer";
import Domains from "../../common/maturityAssessment/domains";

const MaturityDomains = () => {
	const [domains, setDomains] = useState<FrameworkDomain[]>([]);
	const [isSelecting, setIsSelecting] = useState(false);
	const { logout } = useAuth();
	const navigate = useNavigate();
	const { frameworkId } = useParams();
	const {resetChatState, setSelectedUseCase } = useChat();

	const handleSelect = async (index: number) => {
		if (isSelecting) return;
		resetChatState();
		// Set the selected use case
		setSelectedUseCase(index);
		setIsSelecting(true);
		if (index === useCases[0].value) {
			navigate(useCases[0].route);
		} else if (index === useCases[1].value) {
			navigate(useCases[1].route);
		} else if (index === useCases[2].value) {
			navigate(useCases[2].route);
		} else if (index === useCases[3].value) {
			navigate(useCases[3].route);
		}
		setIsSelecting(false);
	};

	const fetchDomains = async (frameworkId: number) => {
		try {
			const domains = await createAxiosInstance().get(
				framework_domains(frameworkId)
			);
			if (domains.status == 401 || domains.status == 403) {
				// 401 is for expired token
				// 403 is for forbidden access (blocked by GPT.)
				console.log("use token expired");
				logout();
				navigate("/");
				return;
			}
			setDomains(domains?.data);
		} catch (e) {
			console.log(e);
		}
	};
	useEffect(() => {
		fetchDomains(Number(frameworkId));
	}, [frameworkId]);

	return (
		<>
			<ChatHeader
				useCase={useCases[useCases.length - 1].value}
				selectUseCase={handleSelect}
			/>
			<main className="d-flex flex-column min-vh-65">
				<Domains
					domains={domains}
					handleQuit={() => navigate(-1)}
					frameworkId={Number(frameworkId)}
				/>
				<Footer />
			</main>
			<ChatHistory
				onNavigate={(path: string) => {
					navigate(path);
				}}
			/>
		</>
	);
};

export default MaturityDomains;
